import React, { useState, useEffect } from 'react';
import { Dropdown, Button, Modal } from 'antd';
import { DownOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import BulkEditDrawer from './BulkEdit/BulkEditDrawer'
import GiftingDrawer from './BulkEdit/giftingDrawer.js';
import BulkPriceDrawer from './BulkEdit/BulkPriceDrawer.js';
import CombineDrawer from '../../VariantProductsDetailView/Combine/combineDrawer.js';
import common_api from '../../../config/common_api.js';
import { triggerNotification } from '../notify.js';

const BulkAction = ({ disabled, selected_data, originaldata, setisloader, reload, globalList, setGlobalList }) => {
  const [data, setData] = useState([]);
  const [modal, contextHolder] = Modal.useModal();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [giftingDrawerOpen, setGiftingDrawerOpen] = useState(false);
  const [combineDrawerOpen, setcombineDrawerOpen] = useState(false);
  const [savedattributes, setSavedattributes] = useState(null);
  const [disableEnrich, setDisableEnrich] = useState(false);
  const [disableBundle, setDisableBundle] = useState(false);
  const [disableCombine, setDisableCombine] = useState(false);
  const [priceDrawerOpen, setpriceDrawerOpen] = useState(false);

  useEffect(() => {
    if (selected_data) {

      const fullData = originaldata.filter(item => selected_data.includes(item.key))
      
      setData(fullData)

      const hasBundleProduct = fullData.every(
        item => item.type == "Bundle"
      );

      const allNullOrUndefined = fullData.every(
        item => item.variant_data == null && item.prdouct_data == null
      );

      const allstoreMatched = fullData.every(
        item => item.store === fullData[0]?.store
      );

      const eachHasOne = fullData.every(
        item =>
          (item.variant_data != null && item.prdouct_data == null) ||
          (item.variant_data == null && item.prdouct_data != null)
      );

      const allHaveVariantData = fullData.every(
        item => item.variant_data != null
      );
      if(hasBundleProduct){  
        setDisableBundle(true)
      }else {
        setDisableBundle(false)
      }
      if (eachHasOne) {
        setDisableEnrich(false)
      } else {
        setDisableEnrich(true)
      }
      if (allNullOrUndefined && allstoreMatched) {
        setDisableCombine(false)
      } else {
        setDisableCombine(true)
      }

    }
  }, [selected_data]);

  const showConfirm = (action, status) => {
    modal.confirm({
      title: null,
      icon: null,
      width: 700,
      className: 'custom-confirm-modal',
      content: (
        <>
          <div className='ModalHeaderBox'>
            <div className='Modal' style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
              <ExclamationCircleFilled style={{ fontSize: 20, color: '#faad14' }} />
              <span className='HeaderTitle' style={{}}>
                Do you want to {action} these products?
              </span>
            </div>
          </div>


          <div className="boxTable">
            <div className="boxHead row">
              <span className='nocol'>No</span>
              <span className='namecol'>BC Name</span>
              <span className='Skucol'>BC SKU</span>
              <span className='storecol'>Store</span>
            </div>
            <div className='BoxBody'>
              {data.map((item, index) => (
                <div className="row" key={index}>
                  <span className='nocol'>{index + 1}</span>
                  <span className='namecol'>{item.bc_name}</span>
                  <span className='Skucol'>{item.bcSku}</span>
                  <span className='storecol'>{item.store}</span>
                </div>
              ))}
            </div>
          </div>
        </>
      ),
      okText: 'Yes',
      cancelText: 'No',
      async onOk() {
        setisloader(true);
        let responsedata = await common_api.updateBulkProductStatus(data, status);

        if (responsedata) {
          let alldata = await common_api.set_all_madded_data_to_variables_bulk(globalList, responsedata)
          if (alldata) {
            await setGlobalList(alldata)
          }
          triggerNotification(responsedata)
        }

        setisloader(false);
      },
      onCancel() {

      },
    });
  };

  const handleMenuClick = async (e) => {
    const selectedData = originaldata.filter((item) =>
      selected_data.includes(item.key)
    );
    setData(selectedData);
    if (e.key === 'activate') {
      showConfirm(e.key, true);
    }
    if (e.key === 'deactivate') {
      showConfirm(e.key, false);
    }
    if (e.key === 'enrich') {
      setDrawerOpen(true);
    }
    else if (e.key === 'CombineAsVariants') {
      setcombineDrawerOpen(true); // <-- fix here
    }
    if (e.key === 'inventorySync') {
      setisloader(true)
      let mappeddata = data.map(item => ({
        product_id: item.prod_id,
        store_id: item.store_id
      }))
      let response = await common_api.syncBulkInventory(mappeddata)
      await reload(true)
      setisloader(false)

      triggerNotification(response)
    }
    if (e.key === 'fetchSAP') {
      setisloader(true)
      await common_api.syncSAP()
      reload(true)
    }
    if (e.key === 'enableGifting') {
      setGiftingDrawerOpen(true);
    }
    if (e.key === 'BulkPrice') {
      setpriceDrawerOpen(true);
    }

  };


  const menuItems = [
    { key: 'enrich', label: 'Enrich', disabled: disableEnrich },
    { key: 'activate', label: 'Activate', disabled: disableEnrich },
    { key: 'deactivate', label: 'Deactivate', disabled: disableEnrich },
    // { key: 'completeSync', label: 'Complete sync' },
    { key: 'inventorySync', label: 'Inventory sync' },
    { key: 'fetchSAP', label: 'Fetch latest data from SAP' },
    { key: 'enableGifting', label: 'Enable gifting', disabled: disableEnrich || disableBundle },
    // { key: 'bulkEdit', label: 'Bulk Edit' },
    { key: 'CombineAsVariants', label: 'Combine as Variants', disabled: disableCombine },
    { key: 'BulkPrice', label: 'Bulk Price', disabled: disableEnrich }
  ];

  return (
    <div>
      <Dropdown
        className="BulkActionsDropdown"
        menu={{ items: menuItems, onClick: handleMenuClick }}
        trigger={['click']}
        disabled={disabled}
      >
        <Button disabled={disabled}>
          Actions <DownOutlined />
        </Button>
      </Dropdown>

      {/* <Button disabled={disabled} onClick={handleBulkBtn}>
        Bulk Edit
      </Button> */}

      {drawerOpen && <BulkEditDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} selectedData={data} setSavedattributes={setSavedattributes} setisloader={setisloader} globalList={globalList} setGlobalList={setGlobalList} />}
      {combineDrawerOpen && <CombineDrawer open={combineDrawerOpen} onClose={() => setcombineDrawerOpen(false)} selectedData={data} reload={reload} setisloader={setisloader} globalList={globalList} setGlobalList={setGlobalList} />}
      {giftingDrawerOpen && <GiftingDrawer open={giftingDrawerOpen} onClose={() => setGiftingDrawerOpen(false)} selectedData={data} setSavedattributes={setSavedattributes} reload={reload} setisloader={setisloader} globalList={globalList} setGlobalList={setGlobalList} />}
      {priceDrawerOpen && <BulkPriceDrawer open={priceDrawerOpen} onClose={() => setpriceDrawerOpen(false)} selectedData={data} setSavedattributes={setSavedattributes} setisloader={setisloader} globalList={globalList} setGlobalList={setGlobalList} />}
      {contextHolder}
    </div>
  );
};

export default BulkAction;
